// Force 1 product per row on mobile (Shoptimized)
function forceOnePerRow() {
  if (window.innerWidth <= 768) {
    // Collection grid
    var products = document.querySelectorAll('.collection-grid .grid__item, .collection-grid .product-grid-item, .collection-grid .product-item');
    products.forEach(function(p) {
      p.style.width = '100%';
      p.style.maxWidth = '100%';
      p.style.float = 'none';
      p.style.display = 'block';
      p.style.clear = 'both';
      p.style.marginBottom = '20px';
    });
  }
}

// Run on page load
window.addEventListener('load', forceOnePerRow);
// Run on resize
window.addEventListener('resize', forceOnePerRow);